import { IconProps } from '@/context/global/types/icon';

const IconArrowUp = ({ className }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="7"
      viewBox="0 0 14 7"
      fill="none"
      className={className}
    >
      <path
        d="M14 6.58594L0 6.58594L6.293 0.292937C6.48053 0.105466 6.73484 0.000150681 7 0.000150681C7.26516 0.000150681 7.51947 0.105466 7.707 0.292937L14 6.58594Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconArrowUp;
